import { 
    LOAD_LIST_DOCTOR, LOAD_A_DOCTOR, ADD_NEW_DOCTOR, UPDATE_A_DOCTOR, DELETE_A_DOCTOR, 
    CLEAR_A_DOCTOR_DETAIL, CLEAR_DOCTOR_ACTION_STATUS, 
} from '../actionTypes';
import { SUCCESS_STATUS, FAILED_STATUS } from '../../constants';

const initialState = {
    doctorList: [],
    doctorDetail: null,
    loading: false,
    error: '',
    actionStatus: undefined,
    actionMsg: ""
};

export default function(state = initialState, action) {
    switch(action.type) {
        case LOAD_LIST_DOCTOR: {
            return {
                ...state,
                doctorList: action.payload,
            }
        }

        case LOAD_A_DOCTOR: {
            return {
                ...state,
                doctorDetail: action.payload
            }
        }

        case ADD_NEW_DOCTOR: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                doctorList: [
                    action.payload.data,
                    ...state.doctorList
                ],
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case UPDATE_A_DOCTOR: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }

            return {
                ...state,
                loading: false,
                doctorList: state.doctorList.map(item => item.id !== action.payload.data.id ? item : action.payload.data),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case DELETE_A_DOCTOR: {
            if(!action.payload || action.payload?.status === 0) {
                return { 
                    ...state,
                    actionStatus: FAILED_STATUS,
                    error: action.payload?.msg
                };
            }
            
            return {
                ...state,
                loading: false,
                doctorList: state.doctorList.filter(item => item.id !== parseFloat(action.payload.data)),
                actionStatus: SUCCESS_STATUS,
                actionMsg: action.payload?.msg
            }
        }

        case CLEAR_A_DOCTOR_DETAIL: {
            return {
                ...state,
                doctorDetail: null,
            }
        }  
        
        case CLEAR_DOCTOR_ACTION_STATUS: {
            return {
                ...state,
                actionStatus: undefined,
                actionMsg: ""
            }
        }

        default:
            return state
    }
}